module.exports = "<!-- View/routes wrapper-->\r\n<router-outlet></router-outlet>\r\n\r\n<!-- toasts -->\r\n<simple-notifications [options]=\"notificationOptions\"></simple-notifications>\r\n<div class=\"site-name-banner\" *ngIf=\"configuration.environmentInfo.showBanner\">{{configuration.environmentInfo.environmentName}}</div>";


//////////////////
// WEBPACK FOOTER
// ./Client/app/components/common/layouts/blank.component.html
// module id = 1112
// module chunks = 0